import React, { useCallback, useState } from 'react';
import VocabularyLearning from '../../../vocabulary/VocabularyLearning';
import { completeSession } from '../../api/activitySessions';

/**
 * VocabularySession - Wrapper for VocabularyLearning that reports session
 * completion to the Rails API.
 */
export const VocabularySession = ({ session, activity, onComplete }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGameComplete = useCallback(async (gameResult) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const finalSnapshot = {
        completed: true,
        total_score: gameResult.total_score,
        completed_items: gameResult.completed_items,
        mastered_item_keys: gameResult.mastered_item_keys
      };

      const result = await completeSession(session.id, finalSnapshot);
      if (result.status === 'success') {
        onComplete(result);
      } else {
        console.error('Unexpected completion status:', result.status);
        alert(result.message || 'Failed to complete activity');
      }
    } catch (error) {
      console.error('Error completing session:', error);
      alert(error.message || 'Failed to complete activity');
    } finally {
      setIsSubmitting(false);
    }
  }, [session.id, onComplete, isSubmitting]);

  return (
    <VocabularyLearning
      activityId={activity.id}
      sessionId={session.id}
      railsEnv={window.railsEnv || 'development'}
      onComplete={handleGameComplete}
    />
  );
};
